import useContent from "@lib/use_content";

interface LocationAmenityIconParams {
  className?: string;
  type: string;
}

export default function LocationAmenityIcon({
  className = "w-10 h-10",
  type,
}: LocationAmenityIconParams) {
  const { data, loading, error } = useContent([
    "beLocAmenIconH",
    "beLocAmenIconNP",
    "beLocAmenIconP",
    "beLocAmenIconV",
  ]);

  if (type == "H") {
    return (
      <svg className="w-5 h-5" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <title>{data?.content.beLocAmenIconH}</title>
        <path
          style={{ fill: "var(--primary-color-darker)" }}
          d="m496.101 385.669 14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055l-62.777-133.608h-139.679c-15.925 0-29.426-11.71-31.679-27.475-33.888-237.217-31.941-222.481-32.321-228.525 0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69h129.961c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-120.818l4.572 32h132.246a32 32 0 0 1 28.962 18.392l57.515 122.407 36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zm-184.743-33.669h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333-64.88 25.953-110.836 89.452-110.836 163.489 0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192z"
        />
      </svg>
    );
  } else if (type == "P") {
    return (
      <svg className="w-7 h-7" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
        <title>{data?.content.beLocAmenIconP}</title>
        <path
          style={{ fill: "var(--primary-color-darker)" }}
          d="m400 32h-352c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-352c0-26.5-21.5-48-48-48zm-160 288h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-224c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
        />
      </svg>
    );
  } else if (type == "NP") {
    return (
      <svg className="w-7 h-7" viewBox="0 0 60.601004 60.601004" xmlns="http://www.w3.org/2000/svg">
        <title>{data?.content.beLocAmenIconNP}</title>
        <path
          style={{ fill: "var(--primary-color-darker)" }}
          d="m28.493677 29.574878h2.155c2.8725 0 5.1625-1.0325 5.1625-4.31 0-3.18625-2.29-4.22-5.1625-4.22h-2.155zm-8.3475-14.455h9.965c9.56125 0 14.05 3.2325 14.05 10.28 0 6.33-4.62375 10.10125-12.435 10.10125h-3.2325v10.95375h-8.3475z"
        />
        <path
          style={{ fill: "var(--primary-color-darker)" }}
          d="m47.234878 44.139878-30.77375-30.7725c3.775-3.1075 8.6125-4.9737503 13.88375-4.9737503 12.07375 0 21.86125 9.7900003 21.86125 21.8625003 0 5.2725-1.86375 10.1075-4.97125 13.88375zm-16.89 7.98125c-12.07625 0-21.8650003-9.7875-21.8650003-21.865 0-5.2275 1.8375003-10.025 4.8987503-13.7875l30.75375 30.7525c-3.7625 3.06125-8.56 4.9-13.7875 4.9m-.045-49.1512503c-15.0925 0-27.3287503 12.2375003-27.3287503 27.3300003 0 15.09375 12.2362503 27.33125 27.3287503 27.33125 15.09375 0 27.33-12.2375 27.33-27.33125 0-15.0925-12.23625-27.3300003-27.33-27.3300003"
        />
      </svg>
    );
  } else if (type == "V") {
    return (
      <svg className="w-6 h-7" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <title>{data?.content.beLocAmenIconV}</title>
        <path
          style={{ fill: "var(--primary-color-darker)" }}
          d="m23 0h-22a1 1 0 0 0 -1 1v21a1 1 0 0 0 1 1h1a1 1 0 0 0 2 0h16a1 1 0 0 0 2 0h1a1 1 0 0 0 1-1v-21a1 1 0 0 0 -1-1zm-1 21h-20v-19h20zm-17-2h10a1 1 0 0 0 1-1v-13a1 1 0 0 0 -1-1h-10a1 1 0 0 0 -1 1v13a1 1 0 0 0 1 1zm9-8v3h-1v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-1v-3zm-8 6v-1h8v1zm8-11v3h-1v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-1v-3zm4 3v-4a1 1 0 0 1 2 0v4a1 1 0 0 1 -2 0zm0 5v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -2 0zm-1 4a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 -1-1z"
        />
      </svg>
    );
  } else if (type == "R") {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 620 572">
        <circle
          cx="130.95011"
          cy="46.58577"
          r="46.54521"
          style={{ fill: "var(--primary-color-darker)" }}
        />
        <path
          d="M124.50539,388.15534V549.98933C124.26193,579.39154,80.494976,579.39154,80.108304,549.98933V388.15534H22.821751L84.404788,171.89962H74.379644L38.57554,295.0651C29.524278,322.30474,-7.3109962,311.27714,1.3392857,282.17574L41.43986,148.98509C46.051436,133.68965,65.32836,106.68061,98.726432,106.02037H128.80188H163.17384C195.6095,106.68061,214.96663,133.91881,220.46041,148.98509L260.56101,282.17574C268.69571,311.1339,232.15259,323.02082,223.32473,295.0651L187.52063,171.89962H176.06331L239.07855,388.15534H180.3598V549.98933C180.8181,579.39154,137.22302,579.2483,137.39487,549.98933V388.15534H124.50539z"
          style={{ fill: "var(--primary-color-darker)" }}
        />
        <circle
          cx="511.90545"
          cy="46.58577"
          r="46.54521"
          style={{ fill: "var(--primary-color-darker)" }}
        />
        <path
          d="M462.49589,106.02037C426.70613,106.02037,403.77713,137.00793,403.77713,167.60313V310.81886C403.44773,338.80318,443.74313,338.80318,443.87777,310.81886V179.06038H453.90289V542.82853C453.28133,580.80938,506.95025,579.72094,506.89297,542.82853V330.86906H515.48597V542.82853C516.18773,579.72094,570.13733,580.80938,569.90817,542.82853V179.06038H579.93333V310.81886C579.46073,339.01802,619.54701,339.01802,620.03389,310.81886V167.60313C619.46109,137.00793,595.67281,106.56889,559.88305,106.02037H462.49589z"
          style={{ fill: "var(--primary-color-darker)" }}
        />
        <rect
          x="297.79132"
          y="5.7684445"
          width="52.996765"
          height="562.84003"
          style={{ fill: "var(--primary-color-darker)" }}
        />
      </svg>
    );
  } else {
    return (
      <div className="relative border-y-2 border-x-[1px]  border-[--primary-color-darker] text-[--primary-color-darker] pt-[2px] px-1 text-sm font-bold font-number">
        {type}
      </div>
    );
  }
}
